import { createCategoryDependencies } from './categoryPermissionDependencies';

/**
 * Aplica as dependências de Treinamentos ao alternar uma permissão da categoria.
 *
 * Marcar "Criar Treinamento" marca automaticamente a "Lista de Treinamentos",
 * pois o botão de criação vive dentro dessa aba. De forma simétrica, desmarcar
 * a "Lista de Treinamentos" remove o "Criar Treinamento" que depende dela.
 */
export const applyTrainingDependencies = createCategoryDependencies({
  categoryName: 'Treinamentos',
  basePermissionKeys: ['read:Training'],
  basePermissionDescriptions: ['Lista de Treinamentos'],
  dependentPermissionKeys: ['create:Training'],
  dependentPermissionDescriptions: ['Criar Treinamento'],
});

export function useTrainingRowPermissions() {
  return {
    applyTrainingDependencies,
  };
}
